import {call, put, takeLatest} from "redux-saga/effects";
import {API} from "../../../api/api";
import {ConfigurationsActionTypes} from "../actions/actionTypes";
import {configurationsAPI} from "../api/api";

function* getProductionServer() {
    try {
        const request = yield call(() =>
            configurationsAPI.getProductionServer()
        );

        yield put({
            type: ConfigurationsActionTypes.GET_PRODUCTION_INFO_SUCCESS,
            payload: request.data
        });
    } catch (e) {
        API.handleError(e.response, "Error getting production info.");

        yield put({
            type: ConfigurationsActionTypes.GET_PRODUCTION_INFO_FAIL,
            message: e.message
        });
    }
}

export function* getProductionServerWatcher() {
    yield takeLatest(ConfigurationsActionTypes.GET_PRODUCTION_INFO, getProductionServer);
}